// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","primaryButton":"Button_primaryButton__3CeEz","secondaryButton":"Button_secondaryButton__35xib"};